import { GLDetailsHeader, GLDetailsHeaderTitle, GlobalViewDetailsContainer, SelectedPinAction } from './GlobalView.styled'
import { XIcon } from 'assets/icons/XIcon'
import { useSelector } from 'react-redux'
import { RootState } from 'store'
import { Box, Flex } from 'styling/GlobalStyles'
import { OtherText, TitleText } from 'styling/Typography'
import Avatar from '../../assets/images/profileAvatar.png'
import { useMemo } from 'react'
import { NoItems } from 'components/NoItems-fallback/NoItems'

export const GlobalViewEmployeesList = ({ list, setList, map }: { map: google.maps.Map, list: { open: boolean, type: string }, setList: React.Dispatch<React.SetStateAction<{ open: boolean, type: string }>> }) => {
    const { users } = useSelector((state: RootState) => state.globalView)

    const u = useMemo<any>(() => users.filter(u => !list.type ? true : u.status.toLowerCase() == list.type.toLocaleLowerCase()), [users, list])


    const handleZoom = (position: { latitude: number, longitude: number }) => {
        if (!position) {
            return
        }
        map.setCenter({ lng: position.longitude, lat: position.latitude })
        map.setZoom(20)
    }

    return <GlobalViewDetailsContainer closed={!list.open} >
        <SelectedPinAction style={{ top: '1.3rem' }} onClick={() => setList({ open: false, type: null })} ><XIcon /></SelectedPinAction>
        <GLDetailsHeader  >
            <GLDetailsHeaderTitle>
                <TitleText weight='bold' >Employees</TitleText>
            </GLDetailsHeaderTitle>
        </GLDetailsHeader>
        <Flex height='100%' column gap='1rem' style={{ overflow: 'auto' }} >
            {u?.length ? u.map(u => <Box key={u.id} style={{ padding: 10, cursor: 'pointer' }} onClick={() => handleZoom(u.position)} >
                <Flex width='100%' gap='1rem' center >
                    <img style={{ borderRadius: 50, border: '1px solid white', minWidth: 40, height: 40 }} src={u.profileImageUrl || Avatar} />
                    <Flex column between width='100%'>
                        <Flex width='100%' between >
                            <TitleText weight='bold' >{u.name}</TitleText>
                            {/* <Flex center gap='5px' >  <RatingIcon /><OtherText>{u.}</OtherText></Flex> */}
                        </Flex>
                        {/* <OtherText weight='bold' >{u.}</OtherText> */}
                        {/* <Flex><OtherText>Status:</OtherText><OtherText weight='bold' >{u.}</OtherText></Flex> */}
                        <Flex><OtherText weight='bold' >{u.role?.name || ' /'}</OtherText></Flex>
                        <Flex><OtherText>Stauts:</OtherText><OtherText weight='bold' >{u.status}</OtherText></Flex>
                        <Flex><OtherText>Task:</OtherText><OtherText weight='bold' >{u.taskName || ' /'}</OtherText></Flex>
                    </Flex>
                </Flex>
            </Box>) : <NoItems marginTop='5rem' title='Employees' />}
        </Flex>




    </GlobalViewDetailsContainer>
}